import { InternalBrandIds } from '../../constants';
const handleImpressionForBrand = ({ event = 0, productSet, visibleItemsInCarousel, praConfiguration, onShow, origin, trackedProductsOnImpression, carouselTitle, }) => {
    var _a;
    const position = event;
    const visibleProducts = productSet.slice(position, position + visibleItemsInCarousel);
    const { TRACKING, SOURCE, BRAND } = praConfiguration;
    let amountOfVisibleUntrackedProducts = 0;
    let containsUntrackedProduct = false;
    const storiesBrandAlignForTracking = BRAND === InternalBrandIds.STORIES ? 'stories' : BRAND;
    const finalData = {
        list_name: carouselTitle || '',
        list_action: onShow ? TRACKING.IMPRESSION : TRACKING.IMPRESSION_CLICK,
        list_sorting: '',
        list_filter: '',
        imp_atelier: [],
        imp_brand: [],
        imp_category: [],
        imp_id: [],
        imp_name: [],
        imp_origin: [],
        imp_original_price: [],
        imp_position: [],
        imp_price: [],
        imp_variant: [],
        imp_origin_system: [],
    };
    visibleProducts.forEach((product) => {
        const formattedArticleCode = `${product.articleCode}`;
        if (!formattedArticleCode || trackedProductsOnImpression.includes(formattedArticleCode)) {
            return;
        }
        trackedProductsOnImpression.push(formattedArticleCode);
        containsUntrackedProduct = true;
        amountOfVisibleUntrackedProducts += 1;
        const { origin: productOrigin, category, articleCode, title, regularPriceValue, redPriceValue, atelierName, variantColor, } = product;
        finalData.imp_position.push(position + amountOfVisibleUntrackedProducts);
        finalData.imp_id.push(`${articleCode || ''}`);
        finalData.imp_category.push(category || '');
        finalData.imp_origin_system.push(productOrigin || ((origin === null || origin === void 0 ? void 0 : origin.length) && origin) || SOURCE || '');
        finalData.imp_brand.push(storiesBrandAlignForTracking || '');
        finalData.imp_name.push(title ? `${title}`.toUpperCase() : '');
        finalData.imp_original_price.push(`${regularPriceValue || ''}`);
        finalData.imp_price.push(redPriceValue ? `${redPriceValue}` : `${regularPriceValue || ''}`);
        finalData.imp_variant.push(variantColor || '');
        finalData.imp_atelier.push(atelierName || '');
        // No data provided, just empty mapping
        finalData.imp_origin.push('');
    });
    if (containsUntrackedProduct) {
        (_a = window.TealiumUtils) === null || _a === void 0 ? void 0 : _a.utagTrackEventLink('', '', '', finalData);
    }
    return trackedProductsOnImpression;
};
export default handleImpressionForBrand;
//# sourceMappingURL=handleImpressionForBrand.js.map